import React, { useEffect } from "react";
import Heading from "../Components/Heading";
import Message from "../Components/Messages";
import { BRAND } from "../config/brand";

function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="main-policy">
      <Heading heading="Terms of Service" />
      <div className="policy-content">
        <Message
          msg="1. Use of services"
          desc={`${BRAND.tokenSymbol} is a digital asset backed by real-world reserves. You are responsible for complying with all applicable laws when using our services. Any fraudulent, unlawful, or harmful activity may result in account suspension or legal action.`}
        />
        <Message
          msg="2. Risk disclaimer"
          desc={`Cryptocurrency investments involve risks, including price volatility and regulatory changes. ${BRAND.name} does not guarantee profits or financial returns, and users are solely responsible for their investment decisions.`}
        />
        <Message
          msg="3. Security & Liability"
          desc="We prioritize security but cannot guarantee absolute protection against cyber threats. Users must safeguard their account credentials and follow best security practices. For details on data protection, refer to our Privacy Policy."
        />
        <Message
          msg="4. Contact Information"
          desc={`For any inquiries regarding these terms, contact us at ${BRAND.contactEmail}. By continuing to use ${BRAND.name}, you acknowledge and agree to these Terms of Service.`}
        />
      </div>
    </div>
  );
}

export default TermsAndConditions;
